export default function syncZoom(viewerA: any, viewerB: any) {
    viewerA.addHandler('zoom', function(event: any) {
        // Get the current zoom level from viewerA
        var zoom = viewerA.viewport.getZoom();
        var zoomB = viewerB.viewport.getZoom();

        // Set the same zoom level on viewerB
        if(zoom !== zoomB){
            console.log("sync zoom", zoom, zoomB)
            viewerB.viewport.zoomTo(zoom);
        }
    });
}
